export default {
  text: {
    label: 'New Textbox',
    keys: ['t'],
    default: false,
    desc: 'Add new textbox to canvas'
  },
  rectangle: {
    label: 'New Rectangle',
    keys: ['m'],
    default: false,
    desc: 'Add new rectangle to canvas'
  },
  circle: {
    label: 'New Circle',
    keys: ['l'],
    default: false,
    desc: 'Add new circle to canvas'
  },
  newPage: {
    label: 'New Page',
    keys: ['n'],
    default: true,
    desc: 'Open the template picker for to create a new page'
  },
  section: {
    label: 'New Section',
    keys: ['k'],
    default: false,
    desc: 'Add section to page, new'
  }
};
